export const SHOW_ALERT="SHOW_ALERT"
export const HIDE_ALERT="HIDE_ALERT"
export const HEADER_READY="HEADER_READY"
export const BODY_READY = "BODY_READY"
export const OK_BUTTON_TEXT_READY = "OK_BUTTON_TEXT_READY"
export const CANCEL_BUTTON_TEXT_READY = "CANCEL_BUTTON_TEXT_READY"
export const HIDE_CLOSE_BUTTON_READY = "HIDE_CLOSE_BUTTON_READY"
export const CALLBACK_READY = "CALLBACK_READY"
export const RESPONSE_READY="RESPONSE_READY"

function show() {
  return {
    type: SHOW_ALERT
  }
}

function hide() {
  return {
    type: HIDE_ALERT
  }
}

function headerReady(text) {
  return {
    type: HEADER_READY,
    payload: text
  }
}

function bodyReady(text) {
  return {
    type: BODY_READY,
    payload: text
  }
}

function okButtonTextReady(text) {
  return {
    type: OK_BUTTON_TEXT_READY,
    payload: text
  }
}

function cancelButtonTextReady(text) {
  return {
    type: CANCEL_BUTTON_TEXT_READY,
    payload: text
  }
}

function hideCloseButtonReady(hide) {
  return {
    type: HIDE_CLOSE_BUTTON_READY,
    payload: hide
  }
}

function callbackReady(callback) {
  return {
    type: CALLBACK_READY,
    payload: callback
  }
}

function responseReady(response) {
  return {
    type: RESPONSE_READY,
    payload: response
  }
}

export const showAlert = () => {
  return dispatch => dispatch(show())
}

export const hideAlert = () => {
  return dispatch => dispatch(hide())
}

export const setupModal = (props, showModal = false) => {
  return dispatch => {
    if (props && props.header !== undefined) dispatch(headerReady(props.header))
    if (props && props.body !== undefined) dispatch(bodyReady(props.body))
    if (props && props.ok_button !== undefined) dispatch(okButtonTextReady(props.ok_button))
    if (props && props.cancel_button !== undefined) dispatch(cancelButtonTextReady(props.cancel_button))
    if (props && props.callback !== undefined) dispatch(callbackReady(props.callback))
    if (props && props.hideCloseButton !== undefined) dispatch(hideCloseButtonReady(props.hideCloseButton))
    return (showModal) ? dispatch(show()) : dispatch(hide())
  }
}

export const setHeader = (text) => {
  return dispatch => dispatch(headerReady(text))
}

export const setBody = (text) => {
  return dispatch => dispatch(bodyReady(text))
}

export const setOkButtonText = (text) => {
  return dispatch => dispatch(okButtonTextReady(text))
}

export const setCancelButtonText = (text) => {
  return dispatch => dispatch(cancelButtonTextReady(text))
}

export const hideCloseButton = (hide) => {
  return dispatch => dispatch(hideCloseButtonReady(hide))
}

export const setCallbackFunction = (callback) => {
  return dispatch => dispatch(callbackReady(callback))
}

export const setAlertResponse = (response) => {
  return dispatch => {
    dispatch(responseReady(response))
  }
}